export default function ProductResults({ t, oem, products }) {
  if (!products) {
    return null;
  }

  if (products.length === 0) {
    return <p className="mt-3 text-xs text-slate-600">{t.emptyProducts}</p>;
  }

  return (
    <div className="mt-3 rounded-lg border border-[#e2e6ec] bg-[#f7f8fa] p-3">
      <p className="text-[11px] font-mono uppercase tracking-[0.14em] text-slate-600 mb-2">
        {t.productsTitle}
      </p>
      <ul className="space-y-2">
        {products.map((pr) => (
          <li key={pr.product_url} className="text-xs">
            <a
              href={pr.product_url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#0b378c] font-semibold hover:underline break-all"
            >
              {pr.product_name}
            </a>
            {pr.brand ? (
              <span className="text-slate-600">
                {" "}
                · {pr.brand}
              </span>
            ) : null}
            <span className="text-slate-500">
              {" "}
              · {pr.source}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
